import { Box } from '@mui/material';
import { Outlet } from 'react-router';
import Header from './Header';
import Footer from './Footer';
import ScrollToTop from './ScrollRestore';

export default function DefaultLayout() {
  return (
    <>
      <Box>
        <Header />
        <ScrollToTop />
        <Box component={'main'}>
          <Outlet />
        </Box>
        <Footer />
      </Box>
    </>
  );
}
